<div
    #aiDialog
    *ngIf="showDialog"
    [@dialogAnim]="{ value: '', params: { startTransform: dialogStartTransform } }"
    class="modeless-dialog"
    cdkDrag
    [ngStyle]="{
    top: dialogState.top + 'px',
    left: dialogState.left + 'px',
    width: dialogState.width + 'px',
    height: dialogState.height + 'px'
    }"
    (cdkDragEnded)="onDragEnded($event)">
    <div class="dialog-header" cdkDragHandle>
        <h2 class="title">Assistant ({{ assistantSettings.name }})</h2>
        <div>
            <button icon-button mat-button (click)="cleanView();">
                <mat-icon>delete_sweep</mat-icon>
            </button>
            <button icon-button mat-button (click)="settings();">
                <mat-icon>settings</mat-icon>
            </button>
            <button icon-button mat-button (click)="hideDialog();">
                <mat-icon>remove</mat-icon>
            </button>
        </div>
    </div>

    <textarea #textArea [(ngModel)]="dialogText" readonly class="dialog-textarea"></textarea>

    <div class="dialog-actions">
        <input
            type="text"
            [(ngModel)]="prompt"
            [disabled]="busy"
            placeholder="Enter your prompt"
            (keyup.enter)="onSend()"
        />

        <button mat-icon-button (click)="toggleListening()" [color]="isListening ? 'warn' : 'primary'" [disabled]="busy">
            <mat-icon>{{ isListening ? 'mic' : 'mic_none' }}</mat-icon>
        </button>

        <button mat-icon-button color="primary" aria-label="Send prompt" (click)="onSend()" [disabled]="busy">
            <mat-icon>send</mat-icon>
        </button>


    </div>

    <!-- Resize handles -->
    <div class="resize-handle top" (mousedown)="startResize($event, 'top')"></div>
    <div class="resize-handle right" (mousedown)="startResize($event, 'right')"></div>
    <div class="resize-handle bottom" (mousedown)="startResize($event, 'bottom')"></div>
    <div class="resize-handle left" (mousedown)="startResize($event, 'left')"></div>
</div>





<ng-template #imageTemplate>
    <h2 mat-dialog-title>{{ imageTitle || 'Image' }}</h2>
    <mat-dialog-content>
        <img [src]="imageUrl" style="max-width: 100%; max-height: 100%;" />

        <div style="display: flex; gap: 12px; margin-top: 12px;">
            <mat-form-field style="flex: 1;">
                <mat-label>Image Title</mat-label>
                <input matInput [(ngModel)]="imageTitle" placeholder="Enter image title" />
            </mat-form-field>

            <mat-form-field style="flex: 1;">
                <mat-label>Image Size</mat-label>
                <input matInput [value]="imageSize" readonly />
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onDownloadImage()">Download</button>
        <button mat-button (click)="dialogRef2.close()">Close</button>
    </mat-dialog-actions>
</ng-template>
